export * as benchResearch from './bench-research'
export * as clinicalResearch from './clinical-research'
export * as clinicalTrials from './clinical-trials'
export * as computational from './computational'
export * as externalOther from './external-other'
export * as federal from './federal'
export * as internalFunding from './internal-funding'
export * as nonProfitFoundation from './non-profit-foundation'
export * as other from './other'
